import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields'
Vue.use(Vuex)

let domain = ''
if(w2c_settings.env === "development") {
  domain = 'http://api.lvh.me:3000'
} else {
  domain = 'https://api.welcometocollege.com'
}

let color = w2c_settings.color ? w2c_settings.color : '#0074bb'
let text_color = w2c_settings.text_color ? w2c_settings.text_color : '#FFFFFF'

let recipient = ''
if (w2c_settings.user) {
  recipient = w2c_settings.user
}

let group = ''
if (w2c_settings.group) {
  group = w2c_settings.group
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let w2c_admin = urlParams.get('w2c_usr')

let url = encodeURIComponent(window.location.href)

const store = new Vuex.Store({
  state: {
    discussion: {
      chat_messages: []
    },
    user_is_live: false,
    recipient: recipient,
    recipient_name_before_chat: '',
    group: group,
    color: color,
    text_color: text_color,
    chat_id: '',
    url: url,
    loading: false,
    fname: '',
    lname: '',
    email: '',
    body: '',
    errors: [],
    chatActivated: false,
    chatEnded: false
  },

  getters: {
    getField,
    sender: state => {
      if (w2c_admin) {
        return w2c_admin
      } else {
        return state.discussion.sender_id
      }
    },
    recipient_name: state => {
      if (w2c_admin) {
        return state.discussion.sender.name
      } else {
        return state.discussion.recipient.name
      }
    }
  },

  mutations: {
    updateField,

    createChat(state, discussion) {
      state.chatEnded = false
      state.discussion = discussion
      state.chat_id = discussion.id
      localStorage.setItem("chat_id", discussion.id);

      Vue.$cookies.set('wtc_chat_usr_id',state.discussion.sender_id);

      let ac = this.$cable.subscribe({
        channel: 'ChatChannel',
        id: state.chat_id,
        user_id: state.discussion.sender_id
      });
    },

    load(state, discussion) {
      state.discussion = discussion
      state.chat_id = discussion.id
      state.chatActivated = true
      state.loading = false

      if (state.discussion.ended_at) {
        state.chatEnded = true
        localStorage.setItem("chat_id", '')
        Vue.$cookies.remove('wtc_chat_usr_id');
      } else {
        Vue.$cookies.set('wtc_chat_usr_id',state.discussion.sender_id);
        let ac = this.$cable.subscribe({
          channel: 'ChatChannel',
          id: state.chat_id,
          user_id: state.discussion.sender_id
        });
      }
    },

    sendMessage(state, message) {
      state.discussion.chat_messages.push(message)
    },

    setErrors(state, errors) {
      state.errors = errors
    },

    clearMessage(state) {
      state.fname = ''
      state.lname = ''
      state.email = ''
      state.body = ''
    },

    endChat(state) {
      state.fname = ''
      state.lname = ''
      state.email = ''
      state.body = ''
      state.discussion = {
        chat_messages: []
      }
      localStorage.setItem("chat_id", '')
      state.chat_id = ''
      state.chatActivated = false
    },

    activateChat(state) {
      state.chatActivated = !state.chatActivated
    },

    appearanceCheck(state, data) {
      // console.log('appearance checked')
      // console.log(data)
      let chat_btn = document.querySelector('#w2c_chat_btn')
      state.recipient_name_before_chat = data.name
      if (data.is_live === true) {
        state.user_is_live = true
        chat_btn.insertAdjacentHTML("afterbegin", "<span style=\"height: 12px; width: 12px; background-color: #0bee0b; margin-right: 5px; border-radius: 50%; display: inline-block;  box-shadow: 1px 1px 5px rgba(255,255,255,0.7);\"></span>")
      }
    }
  },

  actions: {
    async checkAppearance({ commit }, user_or_group) {
      fetch(`${domain}/v1/chats/appearances/${user_or_group}`, {
        headers: { accept: 'application/json' }
      })
        .then(response => response.json())
        .then(data => {
          if (data.errors) {
            console.log(data.errors)
            // commit('setErrors', data.errors)
          } else {
            // commit('setErrors', [])
            commit('appearanceCheck', data)
          }
        })
    },

    async chatActivated({ commit }) {
      commit('activateChat')
    },

    async createChat({ commit }, formData) {
      fetch(`${domain}/v1/chats/`, {
        headers: { accept: 'application/json' },
        method: 'post',
        body: formData
      })
        .then(response => response.json())
        .then(chat => {
          if (chat.errors) {
            commit('setErrors', chat.errors)
          } else {
            commit('setErrors', [])
            commit('clearMessage')
            commit('createChat', chat)
          }
        })
    },

    async loadMessages({ commit }, chat_id) {
      fetch(`${domain}/v1/chats/${chat_id}`, {
        headers: { accept: 'application/json' }
      })
        .then(response => response.json())
        .then(data => {
          if (data.errors) {
            console.log(data.errors)
            commit('setErrors', data.errors)
          } else {
            commit('setErrors', [])
            commit('load', data)
          }
        })
    },

    async loadMessagesFromToken({ commit }, token) {
      fetch(`${domain}/v1/chats/token?token=${token}`, {
        headers: { accept: 'application/json' }
      })
        .then(response => response.json())
        .then(data => {
          if (data.errors) {
            console.log(data.errors)
            commit('setErrors', data.errors)
          } else {
            commit('load', data)
          }
        })
    },

    async sendMessage({ commit }, payload) {
      fetch(`${domain}/v1/chats/${payload.chat_id}/chat_messages`, {
        headers: { accept: 'application/json' },
        method: 'post',
        body: payload.formData
      })
        .then(response => response.json())
        .then(message => {
          if (message.errors) {
            commit('setErrors', message.errors)
          } else {
            commit('setErrors', [])
            commit('clearMessage')
          }
        })
    },

    async endChat({ commit }, chat_id) {
      fetch(`${domain}/v1/chats/${chat_id}/end_chat`, {
        headers: { accept: 'application/json' },
        method: 'put'
      })
        .then(response => response.json())
        .then(message => {
          if (message.errors) {
            commit('setErrors', message.errors)
          } else {
            commit('setErrors', [])
            commit('endChat')
          }
        })

    }
  }
})

window.store = store
export default store